import { useEffect, useState } from 'react';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import { useAuthenticationProvider } from 'infrastructure/security/authentication/AuthenticationProvider';
import useAuthenticatedUserService from 'infrastructure/security/authentication/authenticatedUserService';
import useAvailabilityUserApiService from './useAvailabilityUserApiService';
import { isAvailableFeatures } from '../../helpers';

const useCurrentUserAvailability = () => {
  const { isFeatureEnabled } = useFeatureToggle();
  const { isAuthenticated } = useAuthenticationProvider();
  const { getWorkingEmail } = useAuthenticatedUserService();
  const { checkRecipientAvailability } = useAvailabilityUserApiService();
  const [isAvailabilityEnabled, setAvailabilityEnabled] = useState(false);
  const isInterruptionsFeatureEnabled = isFeatureEnabled(Features.INTERRUPTIONS);

  useEffect(() => {
    if (!isAuthenticated || !isInterruptionsFeatureEnabled) {
      setAvailabilityEnabled(false);
      return undefined;
    }

    let isActual = true;

    const checkAvailability = async () => {
      try {
        const workingEmail = await getWorkingEmail();

        if (!workingEmail) {
          setAvailabilityEnabled(false);
          return;
        }

        const isAvailable = await checkRecipientAvailability(workingEmail);

        if (isActual) {
          setAvailabilityEnabled(isAvailableFeatures(isAvailable));
        }
      } catch {
        if (isActual) {
          setAvailabilityEnabled(false);
        }
      }
    };

    void checkAvailability();

    return () => {
      isActual = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isInterruptionsFeatureEnabled]);

  return {
    isAvailabilityEnabled,
  };
};

export default useCurrentUserAvailability;
